





























































import Vue from "vue";
import NavigationButton from "../../buttons/NavigationButton.vue";
import Shared from "../../../shared";
import storeHelper from "../../../store/store-helper";
import { Portal } from "@infoland/iprova-api";
import Utils from "@/utils";
import { FeatureType } from "@/enums";

export default Vue.extend({
    name: "PortalNavButtonsArea",
    components: { NavigationButton },
    props: {
        portal: Object as () => Portal,
        hasContentItems: Boolean,
        hasFillableContentItems: Boolean,
        hasManagementInfoItems: Boolean
    },
    data() {
        return {
            browseMode: "legacy" as "legacy" | "modern"
        };
    },
    computed: {
        isAnonymousUser(): Boolean {
            return Utils.isAnonymousUser(this.$user.user_id);
        },
        showTasksAndSubscriptions(): boolean {
            return this.$user.show_tasks_and_subscriptions;
        }
    },
    async mounted() {
        var browseFeature = (await storeHelper.FeaturesStore.featureByType(FeatureType.browse_mode_modern))?.enabled ?? false;
        this.browseMode = browseFeature ? "modern" : "legacy";
    },
    methods: {
        redirectToSpecificUrl(specificPath: string) {
            specificPath = this.$t(specificPath).toString();
            location.href = `${Shared.iProvaUrl}/${this.$t("general.route.portal")}/${this.portal.name.replace(
                /[^a-zA-Z0-9-_]/g,
                "_"
            )}/${specificPath}`;
        },
        redirectToBrowse() {
            if (this.browseMode == "modern") {
                this.$router.push({
                    name: "AIBrowse",
                    params: {
                        portalId: this.portal.portal_id.toString()
                    },
                    query: {
                        collectionId: this.portal?.selected_collection?.collection_id.toString()
                    }
                });
                return;
            }

            this.$router.push({
                name: "Browse",
                params: {
                    portalId: this.portal.portal_id.toString(),
                    searchText: null,
                    portalSearch: this.portal.portal_id.toString()
                }
            });
        },
        redirectToFillOut() {
            this.$router.push({ name: "FillOut", params: { portalId: this.portal.portal_id.toString() } });
        },
        redirectToMyTasks() {
            this.$router.push(`/portal/${this.portal.portal_id}/tasks/tasks`);
        },
        redirectToDashboard() {
            this.$router.push({ name: "Dashboard", params: { portalId: this.portal.portal_id.toString() } });
        }
    }
});
